export const eecReportColumns = [
  {
    field: 'No',
    headerName: 'ลำดับ',
    width: 70,
    align: 'center'
  },
  {
    field: 'AptTm',
    headerName: 'วันที่',
    width: 120,
    align: 'center'
  }
]
